import { render, staticRenderFns } from "./MyImg.vue?vue&type=template&id=63641895&scoped=true"
import script from "./MyImg.vue?vue&type=script&lang=js"
export * from "./MyImg.vue?vue&type=script&lang=js"
import style0 from "./MyImg.vue?vue&type=style&index=0&id=63641895&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63641895",
  null
  
)

export default component.exports